import { render, staticRenderFns } from "./EndCampaignNotificationSettings.vue?vue&type=template&id=ede34d82&scoped=true&"
import script from "./EndCampaignNotificationSettings.vue?vue&type=script&lang=js&"
export * from "./EndCampaignNotificationSettings.vue?vue&type=script&lang=js&"
import style0 from "./EndCampaignNotificationSettings.vue?vue&type=style&index=0&id=ede34d82&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ede34d82",
  null
  
)

export default component.exports